export default __webpack_public_path__ + "static/media/local_plugin_assistant_icon_optm.ee5090c0.svg";